/* eslint-disable */
import React from 'react';
import '../styles/HeroBanner.css';

const HeroBanner = () => {
  return (
    <section className="hero-banner">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <span>Ministry of Health</span>
          </div>
          <h1 className="hero-title">
            Strengthening Health Security Through
            <span className="highlight"> Integrated One Health</span>
            Approaches
          </h1>
          <p className="hero-description">
            Leading South Sudan's efforts in disease prevention, emergency response, 
            and multisectoral collaboration to protect communities from health threats.
          </p>
          <div className="hero-actions">
            <button className="btn btn-primary">
              Explore Our Work
            </button>
            <button className="btn btn-secondary">
              Emergency Guidelines
            </button>
          </div>
          <div className="hero-features">
            <div className="feature-item">
              <div className="feature-icon">🛡️</div>
              <span>Health Security</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🚀</div>
              <span>Surge Capacity</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🌍</div>
              <span>One Health</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;